import { Box, Container } from "@mui/material";
import { useLocation } from "react-router-dom";
// import { useAppSelector } from "../../../hooks/redux";
// import { useAction } from "../../../hooks/actions";
// // import { excludeInBreadcrumb, rootPaths } from "../../AppRoutes";
import ModalClosePage from "../../components/Modals/ModalClosePage";
import {
  ErrorRequest,
  ErrorSubmit,
  WarningRequest,
  SuccessSubmit,
  ErrorPermissionRequest,
  ErrorSimpleNotificationModal,
} from "../../components/Notifications";
import "./styles/style.css";

const PageContent = ({ children }) => {
  // const { t } = useTranslation();
  const { pathname } = useLocation();
  // const navigate = useNavigate();

  // const { titlePage } = useAppSelector((state) => state.settings);
  // const { isChangeForm } = useAppSelector((state) => state.organizations);
  // const { setPathForModalClosePage } = useAction();

  // const handleChangePage = (to) => {
  //   isChangeForm ? setPathForModalClosePage(to) : navigate(to);
  // };

  const pathSnippets = pathname.split("/").filter((i) => i);
  if (pathSnippets.length > 0) {
    const lastSegment = pathSnippets[pathSnippets.length - 1];
    if (lastSegment.match(/^\d+$/)) {
      pathSnippets.pop();
    }
  }

  // const extraBreadcrumbItems = pathSnippets.map((_, index) => {
  //   const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
  //   const result = _.split(/(?=[A-Z][a-z])/).join(" ");
  //   const isInclude = excludeInBreadcrumb.includes(`/${result}`);
  //   const isRootPath = rootPaths.includes(`/${result}`);
  //   if (isInclude) return "";

  //   if (isRootPath)
  //     return (
  //       <Typography key="3" className="breadcrumbs-root">
  //         {t(`title_page:${result}`)}
  //       </Typography>
  //     );

  //   return (
  //     <span key={url}>
  //       {index === pathSnippets.length - 1 ? (
  //         <Typography
  //           key="3"
  //           color="text.primary"
  //           className="breadcrumbs-current"
  //         >
  //           {titlePage || t(`title_page:${result}`)}
  //         </Typography>
  //       ) : (
  //         <Typography
  //           key="3"
  //           onClick={() => handleChangePage(url)}
  //           className="breadcrumbs-link"
  //         >
  //           {t(`title_page:${result}`)}
  //         </Typography>
  //       )}
  //     </span>
  //   );
  // });

  return (
    <Box className="page-content">
      <Container maxWidth={false} sx={{ paddingTop: "32px" }}>
        {children}
      </Container>
      <ModalClosePage />
      <ErrorRequest />
      <WarningRequest />
      <ErrorSubmit />
      <SuccessSubmit />
      <ErrorPermissionRequest />
      <ErrorSimpleNotificationModal />
    </Box>
  );
};

export default PageContent;
